module.exports = __webpack_public_path__ + "static/cloak_of_displacement-2c9411a119fda6c5d47f74f80b892458.jpeg";